<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-form-group
          label="Supplier"
        >
          <custom-v-select
            id="supplier"
            v-model="selectedSuppliers"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="supplierOptions"
            label="text"
            placeholder="Select Supplier"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Invoice Number"
        >
          <b-form-input
            v-model="invoiceNo"
            type="text"
            placeholder="Search Invoice Number"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Invoice Date Range"
        >
          <flat-picker
            v-model="invoiceDateRange"
            placeholder="Select Date Range"
            :config="{ mode: 'range'}"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Received Date Range"
        >
          <flat-picker
            v-model="receiveDateRange"
            placeholder="Select Date Range"
            :config="{ mode: 'range'}"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Amount Min"
        >
          <b-form-input
            v-model="amountMin"
            type="number"
            placeholder="Min Amount"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Amount Max"
        >
          <b-form-input
            v-model="amountMax"
            type="number"
            placeholder="Max Amount"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Remarks"
        >
          <b-form-input
            v-model="remarks"
            type="text"
            placeholder="Search Remarks"
            @input="debouncedRemarksHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Created By"
        >
          <custom-v-select
            id="user"
            v-model="selectedUsers"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="userOptions"
            label="fullname"
            placeholder="Select User"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { debounce } from 'lodash'
import axios from 'axios'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import FlatPicker from '@/components/UI/FlatPicker.vue'

export default {
  name: 'CapitalGoodsInvoiceFilter',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    CustomVSelect,
    FlatPicker,
  },
  data() {
    return {
      supplierOptions: [],
      selectedSuppliers: [],
      userOptions: [],
      selectedUsers: [],
      invoiceNo: '',
      invoiceDateRange: '',
      receiveDateRange: '',
      amountMin: '',
      amountMax: '',
      remarks: '',
    }
  },
  watch: {
    invoiceDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
    receiveDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
  },
  created() {
    this.debouncedRemarksHandler = debounce(this.filtersChangeHandler, 500)
    this.fetchOptions()
  },
  beforeDestroy() {
    if (this.debouncedRemarksHandler && this.debouncedRemarksHandler.cancel) {
      this.debouncedRemarksHandler.cancel()
    }
  },
  methods: {
    async fetchOptions() {
      axios.get('/invoices/capital_supplier/', {
        params: {
          page: 1,
          per_page: 500,
        },
      })
        .then(res => {
          this.supplierOptions = (res.data.results || res.data).map(s => ({
            id: s.id,
            text: s.name,
          }))
        })

      const { data: usersList } = await axios.get('/delivery/users_list?retailers_only=false')
      this.userOptions = usersList
    },
    filtersChangeHandler() {
      const filtersdata = {}
      if (this.selectedSuppliers.length > 0) {
        filtersdata.supplier = this.selectedSuppliers.map(s => s.id)
      }
      if (this.selectedUsers.length > 0) {
        filtersdata.user = this.selectedUsers.map(u => u.id)
      }
      if (this.invoiceNo) {
        filtersdata.invoice_no = this.invoiceNo
      }
      if (this.invoiceDateRange) {
        const [fromDate, toDate] = this.invoiceDateRange.split(' to ')
        if (fromDate && toDate) {
          filtersdata.invoice_date_start = fromDate
          filtersdata.invoice_date_end = toDate
        }
      }
      if (this.receiveDateRange) {
        const [fromDate, toDate] = this.receiveDateRange.split(' to ')
        if (fromDate && toDate) {
          filtersdata.receive_date_start = fromDate
          filtersdata.receive_date_end = toDate
        }
      }
      if (this.amountMin) {
        filtersdata.amount_min = this.amountMin
      }
      if (this.amountMax) {
        filtersdata.amount_max = this.amountMax
      }
      if (this.remarks) {
        filtersdata.remarks = this.remarks
      }
      this.$emit('filtersUpdated', filtersdata)
    },
  },
}
</script>
